export var Name = 'request-shopping-context';
export var RequestShoppingContextEvent = Name;